const modalStyles = {
    dialogTitle: {
        fontFamily: 'Arial',
        fontSize: '25px',
        color: '#5A5A5A',
    },
    dialogContent: {
        fontFamily: 'sans-serif',
        lineHeight: '1.5',
        color: '#5A5A5A',
        paddingTop: '16px',
        paddingBottom: '16px',
    },
    closeButton: {
        margin: '10px',
    },
    temp: {
        paddingTop: '16px',
        paddingRight: '24px',
        paddingLeft: '24px',
    },
    divider: {
        margin: '0px 24px',
    },
};

module.exports = { modalStyles };
